import api from "./config";

// 📌 OBTENER TODOS LOS PACIENTES ACTIVOS
export const getPacientes = async () => {
    try {
        const response = await api.get("/pacientes?activo=true");
        return response.data;
    } catch (error) {
        console.error("Error obteniendo pacientes:", error);
        return [];
    }
};

//MODAL ARCHIVADOS 

// pacientes.js
export const getTodosPacientes = async () => {
  const response = await api.get("/pacientes/");
  return response.data;
};

// 📌 AGREGAR PACIENTE
export const addPaciente = async (paciente) => {
    try {
        paciente.activo = true; 
        const response = await api.post("/pacientes/", paciente);
        return response.data;
    } catch (error) {
        console.error("Error agregando paciente:", error);
        return null;
    }
};

// 📌 ACTUALIZAR PACIENTE
export const updatePaciente = async (id, pacienteActualizado) => {
    try {
       
        
        const response = await api.patch(`/pacientes/${id}/`, pacienteActualizado);
      
        
        return response.data;
    } catch (error) {
        console.error("❌ Error actualizando paciente:", error);
        
        // Mostrar más detalles del error
        if (error.response) {
            console.error("Datos del error:", error.response.data);
            console.error("Estado HTTP:", error.response.status);
            console.error("Cabeceras:", error.response.headers);
        } else if (error.request) {
            console.error("No se recibió respuesta del servidor:", error.request);
        } else {
            console.error("Error al configurar la petición:", error.message);
        }
        
        return null;
    }
};

// 📌 ELIMINAR PACIENTE (Marcarlo como inactivo)
export const deletePaciente = async (id) => {
    try {
        const citas = await api.get(`/citas?pacienteId=${id}`);
        for (let cita of citas.data) {
            await api.put(`/citas/${cita.id}`, { ...cita, estado: "cancelada" });
        }
        await api.put(`/pacientes/${id}`, { activo: false });
        return true;
    } catch (error) {
        console.error("Error archivando paciente:", error);
        return false;
    }
};

// 📌 OBTENER CATÁLOGO DE ENTIDADES FEDERATIVAS
export const getCatalogoEntidades = async () => {
  try {
    const response = await api.get("/catalogos/entidades/?limit=500");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo catálogo de entidades:", error);
    return [];
  }
};



// 📌 OBTENER UN SOLO PACIENTE POR ID (detalle completo)
export const getPacienteById = async (id) => {
    try {
        const response = await api.get(`/pacientes/${id}/`);
        return response.data;
    } catch (error) {
        console.error("Error obteniendo paciente por id:", error);
        return null;
    }
};

// 📌 FUSIONAR PACIENTES
// origenId = paciente que desaparece
// destinoId = paciente que se conserva
export const mergePacientes = async (origenId, destinoId) => {
  try {
    const response = await api.post(`/pacientes/${origenId}/merge/`, {
      destino_id: destinoId,
    });
    return response.data;
  } catch (error) {
    console.error("Error fusionando pacientes:", error);

    if (error.response) {
      console.error("Datos del error:", error.response.data);
      console.error("Estado HTTP:", error.response.status);
    }

    throw error;
  }
};
